import { config } from '@fortawesome/fontawesome-svg-core';

import '@fortawesome/fontawesome-svg-core/styles.css';
config.autoAddCss = false;

import React, { useRef } from 'react';
import { useInViewport } from 'react-in-viewport';
import Skeleton from 'react-loading-skeleton';
import {
  faCheck as fasCheck
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Checkers from '../../../../../../helpers/class/Checkers';

export default function Highlights ( props ) {
  const config = { disconnectOnLeave: false };
  const options = {  };
  const myRef = useRef();
  const {
    inViewport
  } = useInViewport(
    myRef,
    options,
    config,
    props
  );

  let viewPortResult = null;
  if ( !inViewport ) {
    viewPortResult =
      <div ref={myRef}>
        <Skeleton height={30} className="col-12 col-sm-6 b-rad-md mb-1"/>
        <Skeleton height={30} className="col-12 col-sm-6 b-rad-md mb-1"/>
        <Skeleton height={30} className="col-12 col-sm-6 b-rad-md mb-1"/>
        <Skeleton height={30} className="col-12 col-sm-6 b-rad-md mb-1"/>
      </div>
    ;
  } else {
    if ( Checkers.isValidArray( props.highlights ) ) {
      viewPortResult =
        <>
          <h2 className="mt-0">Why Guest Love It</h2>
          {
            props.highlights.map( ( highlight ) => (
              <div className="col-12 col-sm-6" key={highlight.tag_id.toString()}>
                <p className="fs-18">
                  <FontAwesomeIcon icon={fasCheck} className="text-master m-r-10" size="1x"/>
                  {highlight.tag_title}
                </p>
              </div>
            ) )
          }
        </>
      ;
    }

  }

  return (
    <div ref={myRef} id="prop_highlights" className="row full-width no-margin pb-5">

      { viewPortResult }
    </div>
  )
}
